import { DashboardSVG, SearchSVG, ConceptSVG, TimelineSVG, ViewDocumentSVG } from "../../../components/icons"
import { ROUTES } from "../../../utils"
import BillingSVG from "../../icons/BillingSVG"
import TextProcessingSVG from "../../icons/TextProcessingSVG"
import UserManagementSVG from "../../icons/UserManagementSVG"

const SuperSetMenu = [
	{
		key: "dashboard",
		title: "Dashboard",
		icon: <DashboardSVG />,
		route: ROUTES.DASHBOARD,
	},
	{
		key: "view_documents",
		title: "Search",
		icon: <SearchSVG />,
		route: ROUTES.VIEW_DOCUMENTS,
		permissions: "Search_Get",
	},
	{
		key: "build_concepts",
		title: "Build Concepts",
		icon: <ConceptSVG />,
		route: ROUTES.BUILD_CONCEPTS,
		permissions: "Concept_Get",
	},
	{
		key: "create_timeline",
		title: "Create Timeline",
		icon: <TimelineSVG />,
		route: ROUTES.TIMELINE,
		permissions: "Search_Execute",
	},
	{
		key: "text_processing",
		title: "Case Management",
		icon: <TextProcessingSVG />,
		route: ROUTES.BIFROST,
		permissions: "Bifrost_Case_Get",
	},
	{
		key: "user_management",
		title: "User Management",
		icon: <UserManagementSVG />,
		route: ROUTES.USER,
		permissions: "User_Get",
	},
	{
		key: "user_management",
		title: "Billing",
		icon: <BillingSVG />,
		route: ROUTES.BILLING,
		permissions: "Billing_Get",
	},
]

export default SuperSetMenu
